import {Component, Input, OnInit} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  imports: [
    NgClass
  ],
  standalone: true
})
export class LoadingSpinnerComponent implements OnInit {
  @Input() type = '';

  constructor() { }

  ngOnInit(): void {
  }

}
